import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { formatErrorKeys } from '../../formatErrorKeys';
import { IdentificationValidationResult, ValidationResponse } from '../types';

type EmailValidationField = 'email';
type EmailValidationAnyError = 'email' | 'email_exists' | 'email_format' | 'illegal_domain';
type EmailValidationInvalidError = Exclude<EmailValidationAnyError, 'email_exists'>;

export const validateEmailForIdentification = async (
    email: string
): Promise<IdentificationValidationResult<EmailValidationInvalidError>> => {
    const url = pathfinder('validate_email');

    try {
        const { data } = await axios.post<ValidationResponse<EmailValidationField, EmailValidationAnyError>>(url, {
            email,
        });
        const formattedErrors = formatErrorKeys(data.errorKeys);

        if (formattedErrors.email?.includes('email_exists')) {
            return {
                exists: true,
                valid: true,
            };
        }

        return {
            exists: false,
            valid: data.status === 'success',
            errorKeys: formattedErrors.email as EmailValidationInvalidError[],
        };
    } catch (_error) {
        return {
            exists: false,
            valid: false,
        };
    }
};
